import React from 'react';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import Text from './styled';
import formatNumber from 'Common/Functions/FormatNumber';
import Skeleton from 'Common/Components/Skeleton';

const GenericCell = ({
  rowInfo, capitalize, attrib, showSkeleton
}) => {
  const label = get(rowInfo, attrib, '') ?? '';
  let labelFormatted = (attrib === 'vulns' || attrib === 'credentials') ? formatNumber(label) : label;
  if (attrib === 'description' && labelFormatted.length > 100) labelFormatted = `${labelFormatted.slice(0, 100)}...`;

  if (showSkeleton) return <Skeleton />;
  if (attrib === 'owned') {
    return (
      <Text capitalize={ capitalize }>
        <FormattedMessage id={ label ? 'host.table.columns.owned.true' : 'host.table.columns.owned.false' } />
      </Text>
    );
  }
  return (
    <Text capitalize={ capitalize } title={ attrib === 'description' ? label : undefined }>
      { labelFormatted }
    </Text>
  );
};

export default GenericCell;
